// src/components/filter/PriceFilter.jsx

import React, { useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFilter } from "../../redux/actions/filterActions";

const PriceFilter = () => {
  const dispatch = useDispatch();
  const { isAuthenticated, loggingOut } = useSelector((state) => state.auth);
  const debounceTimeout = useRef();

  // “Chosen” price range (min, max) from Redux
  const { price } = useSelector((state) => state.filters);

  // “Available” price range from the filterOptions
  const { data: opts = {} } = useSelector((state) => state.filterOptions) || {};
  const minLimit = opts.priceRange?.min ?? 0;
  const maxLimit = opts.priceRange?.max ?? 5000;
  const minGap = 1;

  // Map Redux state to local variables
  const minPrice = price.min;
  const maxPrice = price.max;

  const handleMinChange = (e) => {
    const val = Number(e.target.value);
    const newMin = Math.min(val, maxPrice - minGap);
    clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      dispatch(setFilter("price", { min: newMin, max: maxPrice }));
    }, 400);
  };

  const handleMaxChange = (e) => {
    const val = Number(e.target.value);
    const newMax = Math.max(val, minPrice + minGap);
    clearTimeout(debounceTimeout.current);
    debounceTimeout.current = setTimeout(() => {
      dispatch(setFilter("price", { min: minPrice, max: newMax }));
    }, 400);
  };

  return (
    <div className="my-4">
      <h6 className="font-semibold lg:text-lg mb-2">Price</h6>
      <div className="relative h-3 bg-gray-300 rounded-full">
        <div
          className="absolute h-3 bg-teal-700 rounded-full"
          style={{
            left: `${((minPrice - minLimit) / (maxLimit - minLimit)) * 100}%`,
            right: `${
              100 - ((maxPrice - minLimit) / (maxLimit - minLimit)) * 100
            }%`,
          }}
        />
      </div>
      <div className="relative">
        <input
          type="range"
          min={minLimit}
          max={maxLimit - minGap}
          disabled={!isAuthenticated}
          value={minPrice}
          onChange={handleMinChange}
          className="w-full appearance-none bg-transparent absolute pointer-events-auto -mt-5"
        />
        <input
          type="range"
          min={minLimit + minGap}
          max={maxLimit}
          disabled={!isAuthenticated}
          value={maxPrice}
          onChange={handleMaxChange}
          className="w-full appearance-none bg-transparent absolute pointer-events-auto -mt-2"
        />
      </div>
      <div className="flex justify-between text-sm mt-2">
        <span>Min: {minPrice}</span>
        <span>Max: {maxPrice}</span>
      </div>
    </div>
  );
};

export default PriceFilter;
